var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Channels(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 40H46a6 6 0 00-6 6v13a6 6 0 006 6h13a6 6 0 006-6V46a6 6 0 00-6-6zm2 19a2 2 0 01-2 2H46a2 2 0 01-2-2V46a2 2 0 012-2h13a2 2 0 012 2v13zm-2-48H46a6 6 0 00-6 6v13a6 6 0 006 6h13a6 6 0 006-6V17a6 6 0 00-6-6zm2 19a2 2 0 01-2 2H46a2 2 0 01-2-2V17a2 2 0 012-2h13a2 2 0 012 2v13zM36 46v13a6 6 0 01-6 6H17a6 6 0 01-6-6v-1h4v1a2 2 0 002 2h13a2 2 0 002-2V46a2 2 0 00-2-2H17a2 2 0 00-2 2h-4a6 6 0 016-6h13a6 6 0 016 6zm-6-35H17a6 6 0 00-6 6v13a6 6 0 006 6h13a6 6 0 006-6V17a6 6 0 00-6-6zm2 19a2 2 0 01-2 2H17a2 2 0 01-2-2V17a2 2 0 012-2h13a2 2 0 012 2v13zM21 54H7v-4h14v-5l6.78 7L21 59v-5z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Channels.0961b2ba.svg";
export { SvgJ2Channels as ReactComponent };